import PointerProps from './PointerProps'

let KendoLinearGaugePointer = {
    name: 'kendo-lineargauge-pointer',
    render () {
        return null
    },
    mixins: [PointerProps]
}

export default KendoLinearGaugePointer


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoLinearGauge/KendoLinearGaugePointer.js